import { BehaviorSubject } from 'rxjs';

// public sub
export const overlayListener = new BehaviorSubject({
  overlayID: null,
  overlayOrder: 0,
});

// private publicator
export const overlayChannel = {
  send: msg => {
    overlayListener.next({
      ...overlayListener.value,
      ...msg,
    });
  },
  clear: () => {
    overlayListener.next({
      overlayID: null,
      overlayOrder: 0,
    });
  },
};
